/**
 * /p/:slug → /stima/{referral_code}
 *
 * iter v28 r367 — User M1277: unifichiamo le superfici pubbliche.
 * La vecchia landing magazine `/p/{slug}` viene rediretta al funnel
 * stima `/stima/{code}` (single source of truth). Il backend fornisce
 * un endpoint pubblico che mappa slug → code.
 *
 * Se il code non è disponibile (slug non valido o errore di rete),
 * mostra fallback minimo con CTA torna alla home pubblica.
 */
import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL } from "@/lib/api";
import { Spinner } from "@phosphor-icons/react";

export default function LegacySlugRedirect() {
  const { slug } = useParams();
  const [code, setCode] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) return;
    axios.get(`${BACKEND_URL}/api/public/agent/${slug}/code`)
      .then((r) => {
        const c = (r.data?.referral_code || r.data?.code || "").toUpperCase();
        if (c) setCode(c);
        else setNotFound(true);
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (code) return <Navigate to={`/stima/${code}`} replace />;
  if (notFound) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center">
      <Spinner size={28} className="animate-spin text-[#7C8B6E]" />
    </div>
  );
}
